import React, { useMemo } from "react";

// Floating ambient bubbles background. Rendered once at app root.
// Bubbles are non-interactive and respect prefers-reduced-motion.
const Bubbles = ({ count = 22 }) => {
  const bubbles = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      const size = Math.random() * 80 + 20; // 20px - 100px
      const left = Math.random() * 100;
      const duration = Math.random() * 18 + 14; // 14s - 32s
      const delay = Math.random() * -30; // start at different points
      const drift = (Math.random() - 0.5) * 80; // horizontal drift
      return {
        id: i,
        size,
        left,
        duration,
        delay,
        drift,
      };
    });
  }, [count]);

  return (
    <div className="bubbles-container" data-testid="ambient-bubbles" aria-hidden="true">
      {bubbles.map((b) => (
        <span
          key={b.id}
          className="bubble"
          style={{
            width: `${b.size}px`,
            height: `${b.size}px`,
            left: `${b.left}%`,
            animationDuration: `${b.duration}s`,
            animationDelay: `${b.delay}s`,
            "--drift": `${b.drift}px`,
          }}
        />
      ))}
    </div>
  );
};

export default Bubbles;
